import { createOidcApiInstance, createSimpleOidcApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as oidc from '@/api-generator/oidc/index'

const CLIENT_ID = import.meta.env.VITE_CLIENT_ID
const CLIENT_SECRET = import.meta.env.VITE_CLIENT_SECRET

const AuthorizationApi = createSimpleOidcApiInstance(oidc.AuthorizationApi)
const RegisterApi = createOidcApiInstance(oidc.RegisterApi)

/** 取得 Token
 * @param oauthCode OAuth 授權碼
 * @param codeVerifier PKCE Code Verifier
 * @param redirect_uri 重導向 URI
 */
export const getOauthAccessToken = async (oauthCode: string, codeVerifier: string, redirect_uri: string) => {
  const reqBody = {
    grant_type: 'authorization_code',
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    code: oauthCode,
    redirect_uri,
    code_verifier: codeVerifier
  }
  const res = await handleApiStatus(() =>
    AuthorizationApi.postAuthorizationExchange(
      reqBody.grant_type,
      reqBody.client_id,
      reqBody.client_secret,
      undefined, // username
      undefined, // password
      undefined, // scope
      reqBody.code,
      reqBody.redirect_uri,
      reqBody.code_verifier
    )
  )
  return res
}

/** 註冊外部使用者 */
export const registerExternal = async (invitationCode: oidc.ExternalRq) => {
  const res = await handleApiStatus(() => RegisterApi.postRegisterExternal(invitationCode))
  return res
}
